import { Observable, Subject, BehaviorSubject, of } from 'rxjs';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Router } from '@angular/router';

import { OfflineBookingAllList } from '../Models/OfflineBookingProperties';
import { OfflineBookingList } from '../Models/OfflineBookingProperties';
import { OfflineRequestTypes } from '../Models/ActiveClasses';
import { OfflineRequestService } from '../Services/offline-request.service';
import { NgForm } from '@angular/forms';
import { Component } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TicketDataRequest } from '../Models/TicketIssuanceProperties';
import { TicketIssuanceService } from '../Services/ticketIssuance.service';
import * as $ from 'jquery';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { DxDataGridModule } from 'devextreme-angular';
import { DxoFilterRowModule, DxiColumnModule, DxiButtonModule, DxoSearchPanelModule, DxoPagingModule, DxoPagerModule } from 'devextreme-angular/ui/nested';
@Component({
    selector: 'app-offline-my-booking-tkt-list',
    templateUrl: './offline-my-booking-tkt-list.component.html',
    styleUrls: ['./offline-my-booking-tkt-list.component.css'],
    imports: [NavMenuComponent, DxDataGridModule, DxoFilterRowModule, DxiColumnModule, DxiButtonModule, DxoSearchPanelModule, DxoPagingModule, DxoPagerModule]
})
/** offlineMyBookingTktList component*/
export class OfflineMyBookingTktListComponent {
  /** offlineMyBookingTktList ctor */
 
  constructor(private service: OfflineRequestService, private router: Router) {
    this.onClickEditRequest = this.onClickEditRequest.bind(this);
  }
  userId: number = 0;
  agencyId: string = "";
  bookingIdplusAgencyId: string = "";
  requestList: OfflineBookingAllList[];
  requestListForConverting: OfflineBookingAllList[];
  collapsed = false;
  ngOnInit() {

    try {
      this.userId = Number(localStorage.getItem("UserId"));
      this.agencyId = localStorage.getItem("AgencyId");

      this.loadBaseData();

    } catch (ex) { console.log(ex); }
  }
  
  loadBaseData() {
    this.service.getTicketRequestList(this.userId, this.agencyId).subscribe((data) => {
     
      this.requestListForConverting = data;
      for (let i = 0; i < this.requestListForConverting.length; i++) {
        let bookingdashAgencyId = `${this.requestListForConverting[i].agencyId}-${this.requestListForConverting[i].offlineBookingId}`

        this.requestListForConverting[i].bookingAgencyId = bookingdashAgencyId;
        
        let travelDateFormat=this.requestListForConverting[i].travelDate;

        let dateDateLong: Date = new Date(travelDateFormat);
        let datePipe: DatePipe = new DatePipe('en-UK');
        this.requestListForConverting[i].travelDate = (datePipe.transform(dateDateLong, 'dd/MM/yyyy'));

        let bookingDateFormat = this.requestListForConverting[i].creationDate;

        let datebookDateLong: Date = new Date(bookingDateFormat);
        let datebookPipe: DatePipe = new DatePipe('en-UK');
        this.requestListForConverting[i].creationDate = (datebookPipe.transform(datebookDateLong, 'dd/MM/yyyy'));
        
      }
      this.requestList = this.requestListForConverting;
    });
  }
  onClickEditRequest(e) {

     //20-jan-24
     if (e.row.data.requestTypeName.includes("Offline Booking")) {
      localStorage.setItem("OfflineBookingRequestID", e.row.data.offlineBookingId);
      this.router.navigateByUrl('/offlineBookingRequestCreate');
    }
    //end
    else {
       if (e.row.data.requestTypeName == "Offline Ticket Request") {
         localStorage.setItem('fromOfflineRequestRoute', 'offline-my-booking-tkt-list');
         localStorage.setItem('RequestActionOffline', 'User');
         localStorage.setItem('RequestTypeOffline', 'View');
         localStorage.setItem("offlineBookingId", e.row.data.offlineBookingId);
         this.router.navigateByUrl('/offlineNewAddEdit');
       }
       else {
         localStorage.setItem('fromOfflineRequestRoute', 'offline-my-booking-tkt-list');
         localStorage.setItem("offlineBookingId", e.row.data.offlineBookingId);
         localStorage.setItem("fromRoute", 'offlineapprovedReject');
         this.router.navigateByUrl('/offlineRequestAddEdit');
       }
     
    }
    
  }
  onCellPrepared(e) {
    if (e.rowType === "data" && e.column.dataField === "requestTypeName") {
      /* #7df481 */

      if (e.data.requestTypeName === "Offline Ticket Request") {
        e.cellElement.style.color = "red";
        e.cellElement.style.fontWeight = "700";
      }
      if (e.data.requestTypeName === "Offline Void Request") {
        e.cellElement.style.color = "orange";
        e.cellElement.style.fontWeight = "700";
      }
      if (e.data.requestTypeName === "Offline Refund Request") {
        e.cellElement.style.color = "green";
        e.cellElement.style.fontWeight = "700";
      }
      if (e.data.requestTypeName === "Online Ticket Request") {
        e.cellElement.style.color = "red";
        e.cellElement.style.fontWeight = "700";
      }
      if (e.data.requestTypeName === "Online Void Request") {
        e.cellElement.style.color = "orange";
        e.cellElement.style.fontWeight = "700";
      }
      if (e.data.requestTypeName === "Online PNR Cancel Request") {
        e.cellElement.style.color = "blue";
        e.cellElement.style.fontWeight = "700";
      }
      if (e.data.requestTypeName === "Online Refund Request") {
        e.cellElement.style.color = "green";
        e.cellElement.style.fontWeight = "700";
      }
      // Tracks the `Amount` data field
      //e.watch(function () {
      //  return e.data.requestType;
      //}, function () {
      //  e.cellElement.style.color = e.data.requestType = "Offline Ticket Request" ? "green" : "red";
      //})
    }
  }
  contentReady = (e) => {
    $(".dx-datagrid-headers").css({ "background-color": "#f9f9f9", "color": "#212529", "font-weight": "bold" });
    $(".dx-datagrid-header-panel").css({ "background-color": "#f9f9f9" });
    $(".dx-toolbar-items-container").css({ "background-color": "#f9f9f9" });
    $(".dx-row.dx-data-row.dx-row-lines.dx-column-lines").css({ "border": "none", "background-color": "#f9f9f9" });
    if (!this.collapsed) {
      this.collapsed = true;
      e.component.expandRow(["EnviroCare"]);
    }
  };
}
